import { Flex, ProgressBitbot, Text } from '@bitrise/bitkit';
import React, { FunctionComponent } from 'react';

const PageLoad: FunctionComponent = () => (
  <Flex alignChildren="middle" direction="horizontal" grow>
    <Flex textColor="grape-3">
      <ProgressBitbot />
      <Text config="9">Beep Boop Beep</Text>
    </Flex>
  </Flex>
);

export default PageLoad;
